// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2szoZ","content":"styles_content__QuJ8v"};